<div id="request-details">
    <div class="main_profile">
      <div class="modal-header switch_header">
        <ng-container>
          <div class="col-lg-12 col-xl-12 col-12">
            <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
              Request Details
            </h3>
          </div>
        </ng-container>
      </div>
      <div class="modal-body bg-white body-content">
        <ng-container>
          <div class=" details col-lg-12 col-md-12 px-sm-5 px-0 ">
            <div class="row  pt-lg-4">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Requested Date:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.requested_at ? (data.requested_at | dateonly:'MM/DD/yyyy') : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Completed:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.completed_at ? (data.completed_at | dateonly:'MM/DD/yyyy') : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 text-nowrap">
                <label class="">Status:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label>{{ data.status }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Reason:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="breakword">{{ data.reason ? data.reason : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Note:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="note">{{ data.note ? data.note : '--' }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <label class="">Upload Link:</label>
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6">
                <label class="breakword">
                  <a *ngIf="data.upload_link; else noLink" class="blue-link" [href]="data.upload_link" target="_blank">
                    {{ data.upload_link }}
                  </a>
                  <ng-template #noLink>--</ng-template>
                </label>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="dropdown-footer">
      <div class="row justify-content-end">
        <button class="btn btn-outline-secondary lg-btn ok-btn" (click)="closeAction()">
          Close
        </button>
      </div>
    </div>
</div>
